module.exports = __webpack_public_path__ + "images/bannerDE-ebc3cc6c86bfe359f43a2571fe91aa96.png";